import './riskScoreTooltipText.less'
import { URL_RISK_SCORE, URL_SETTINGS } from '../../../../constants'
import { Button, Typography } from '@lightbeamai/design-system'
import { ArrowSquareOut } from 'phosphor-react'
import React from 'react'
import { useIntl } from 'react-intl'

export const RiskScoreTooltipText = () => {
  const intl = useIntl()
  return (
    <div className="xs-p-8 risk-score-tooltip-text-container">
      <Typography type={'strong'} className="xs-mb-8" color="white" variant={'baseMinus2'}>
        {intl.formatMessage({ id: 'attributeManagementSettings.riskScore' })}
      </Typography>
      <Typography color="white" variant={'baseMinus2'}>
        {intl.formatMessage({ id: 'settings.riskScore.tooltip.info' })}
      </Typography>
      <Button
        className="align-center tooltip-risk-score-know-more"
        variant="link"
        href={URL_SETTINGS + URL_RISK_SCORE}
        target="_blank"
      >
        <Typography variant={'base'} color="white" as="span">
          {intl.formatMessage({ id: 'settings.riskScore.tooltip.button.knowMore' })}{' '}
        </Typography>
        <ArrowSquareOut weight="bold" color="white" />
      </Button>
    </div>
  )
}
